export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7236.6817ba6a.jpg";